import React from 'react'
import { Button } from 'antd'
import { useIntl } from 'react-intl'
import ParticlesOverlay from 'components/LayoutComponents/ParticlesOverlay'

const ErrorNotice = ({ isAuthenticated = false, navigate, id, buttonFunc, reportBug = false }) => {
  const intl = useIntl()

  const btnFunc = buttonFunc || (() => navigate(isAuthenticated ? '/overview' : '/'))

  return (
    <ParticlesOverlay fullscreen={isAuthenticated}>
      <h1 className="mb-4">
        <strong>{intl.formatMessage({ id: `${id}.heading` })}</strong>
      </h1>
      <p className="mb-4">{intl.formatMessage({ id: `${id}.description` })}</p>
      <Button size="large" onClick={btnFunc}>
        {intl.formatMessage({ id: `${id}.button` })}
      </Button>
      {isAuthenticated && reportBug && (
        <Button size="large" onClick={() => navigate('/report-bug')}>
          {intl.formatMessage({ id: `${id}.reportBug` })}
        </Button>
      )}
    </ParticlesOverlay>
  )
}

export default ErrorNotice
